import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Extract the URL hash parameters
    const hash = window.location.hash;
    const urlParams = new URLSearchParams(hash.substring(1));
    const type = urlParams.get('type');

    if (type === 'signup') {
      // This is an email verification callback
      // Redirect to our email verification handler
      navigate('/auth/verify-email' + window.location.hash);
    } else {
      // Other auth callbacks, redirect to dashboard
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Processing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
